import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import ReactSelect from 'react-select';
import FormikReactSelect from '../Common/ReactSelect';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import InputMask from 'react-input-mask';
import * as Yup from 'yup'
import { useFormik } from 'formik';
import Input from '../Common/Input';
import Textarea from '../Common/Textarea';
import { useNavigate } from 'react-router-dom';

const Create = () => {

    const navigate = useNavigate()
    const roleId = localStorage.getItem('rl');
    const [paymentType, setPaymentType] = useState('debit');
    const [step, setStep] = useState(1);
    const [nationalCode, setNationalCode] = useState('');
    const [searched, setSearched] = useState('');
    const [deliverAmount, setDeliverAmount] = useState(0);
    const [totalAmount, setTotalAmount] = useState(0);
    const [isPaid, setIsPaid] = useState(false);
    const [hasError, setHasError] = useState(true);
    const [businessId, setBusinessId] = useState(0);
    const [groupId, setGroupId] = useState(0);
    const [serviceId, setServiceId] = useState(0);
    const [subServiceId, setSubServiceId] = useState(0);
    const [basket, setBasket] = useState([]);
    const [terminals, setTerminals] = useState([]);
    const [terminalNumber, setTerminalNumber] = useState('');
    const [serialNumber, setSerialNumber] = useState('');
    const [debitAmount, setDebitAmount] = useState('');
    const [cashAmount, setCashAmount] = useState('');
    const [debitPaid, setDebitPaid] = useState(false);
    const [cashPaid, setCashPaid] = useState(false);
    const [totalPaidAmount, setTotalPaidAmount] = useState(0);
    const [allBusiness, setAllBusiness] = useState([]);
    const [business, setBusiness] = useState([]);
    const [person, setPerson] = useState({});
    const [personID, setPersonID] = useState(0);
    const [personAddress, setPersonAddress] = useState([]);
    const { readData: getPersons } = useEntityCrud('Person/GetAllPersons');

    const { readData: getSingleBusiness } = useEntityCrud('Business/GetBusiness?BusinessId=' + businessId);
    const { readData: getDeliveryPrice } = useEntityCrud('Business/getDeliverPrice?BusinessId=' + businessId);
    const { readData: getBusiness } = useEntityCrud('Business/GetAllBusiness');
    const { readData: getAddressPerson } = useEntityCrud('Address/getAllAddress?personId=' + personID + '&isActive=true');

    const [allGroups, setAllGroups] = useState([]);
    const [groups, setGroups] = useState([]);
    const { readData: getGroups } = useEntityCrud('Group/GetAllGroups?buisnessId=' + businessId);
    const [allServices, setAllServices] = useState([]);
    const [services, setServices] = useState([]);
    const { readData: getServices } = useEntityCrud('Service/GetAllServices?groupId=' + groupId);
    const [allSubServices, setAllSubServices] = useState([]);
    const [subServices, setSubServices] = useState([]);
    const { readData: getSubServices } = useEntityCrud('SubService/GetAllSubServices?serviceId=' + serviceId);
    const [serviceConsumerId, setServiceConsumerId] = useState(0);
    const { addData: createServiceConsumer } = useEntityCrud('ServiceConsumer/SetServiceConsumer');
    const [factor, setFactor] = useState({});
    const { readData: getServiceConsumerData } = useEntityCrud('ServiceConsumer/GetServiceConsumer');
    const { addData: addPayment } = useEntityCrud('Payment/PaybyCloseloop');
    const [paymentId, setPaymentId] = useState(0);
    const [addressType, setAddressType] = useState('');
    const [addressId, setAddressId] = useState(0);

    const { addData: addAddress } = useEntityCrud('Address/setAddress');

    const { addData: createPayment } = useEntityCrud('Payment/SetPayment');
    const { addData: getPayment } = useEntityCrud('Payment/GetPayment?id=' + paymentId);
    const { addData: getToken } = useEntityCrud('Payment/getToken');
    const [userDetails, setUserDetails] = useState({
        name: '',
        lastName: '',
        cellphone: '',
        nationalCode: '',
        insuranceNo: '',
        insuranceDate: '',
        description: ''
    });
    const [otp,setOtp] = useState('');
    const [sentOtp,setSentOtp] = useState(false);
    const [otpCounter,setOtpCounter] = useState('');

    const [provinces,setProvinces] = useState([]);
    const [cities,setCities] = useState([]);
    const { readGetDataById: getProvinces } = useEntityCrud('Info/GetProvinces');

    const findPerson = e => {
        debugger
        e.preventDefault();
        document.getElementById('button-addon').classList.add('btn-loading');
        const postedData = {
            name: '',
            lastName: '',
            phone: '',
            cellphone: '',
            email: '',
            branchTitle: '',
            nationalCode
        };
        getPersons(postedData).then(({ data }) => {
            debugger
            if (data.status && data.result.length) {
                setPerson(data.result[0]);
                setUserDetails({
                    name: data.result[0].name,
                    lastName: data.result[0].lastName,
                    cellphone: data.result[0].cellphone,
                    nationalCode: data.result[0].nationalCode,
                    insuranceNo: data.result[0].insuranceNo,
                    insuranceDate: data.result[0].insuranceDate,
                    description: data.result[0].description
                });
                setPersonID(data.result[0].id)

                setHasError(false);
            } else {
                setPerson({});
                setHasError(true);
            }
        }).finally(() => {
            setSearched(true);
            document.getElementById('button-addon').classList.remove('btn-loading');
        })
    }

    const getAddress = () => {
        getAddressPerson().then((response) => {
            setPersonAddress(response.data.result)
        })
    }

    useEffect(() => {
        if(personID)
            getAddress()
    }, [personID])

    useEffect(() => {
        if(addressId){
            const postedData = {
                businessId
            }
            getDeliveryPrice(postedData).then(({data}) => {
                setDeliverAmount(data.result)
            })
        }
    },[addressId])

    useEffect(() => {

        getBusiness().then(({ data }) => {

            let businesses = [];
            if (data.status) {
                setAllBusiness(data.result);
                if (localStorage.getItem('rl') != 1 && localStorage.getItem('rl') != 2) {
                    console.log('if');
                    data.result.map(item => {
                        if (item.isActive && localStorage.getItem('businessId').split(',').includes(item.id.toString()))
                            businesses.push({
                                label: item.title,
                                value: item.id
                            });
                    })
                } else {
                    data.result.map(item => {
                        // if (item.isActive)
                            businesses.push({
                                label: item.title,
                                value: item.id
                            });
                    })
                }
            }
            setBusiness(businesses);
            setBusinessId(parseInt(localStorage.getItem('businessId')));
        });
    }, [])

    useEffect(() => {
        if (totalPaidAmount == factor.totalPay)
            setIsPaid(true);
    }, [totalPaidAmount])

    useEffect(() => {
        if (debitAmount <= factor.totalPay)
            setCashAmount(factor.totalPay - debitAmount);
        else {
            setDebitAmount(factor.totalPay);
            setCashAmount('0');
        }
    }, [debitAmount])

    useEffect(() => {

        if (businessId != 0 && businessId != NaN && typeof businessId == 'number') {

            getGroups().then(({ data }) => {

                let groups = [];
                if (data.status) {
                    setAllGroups(data.result);
                    data.result.map(item => {
                        groups.push({
                            label: item.title,
                            value: item.id
                        });
                    })
                }
                setGroups(groups);
            })
            if (businessId) {

                getSingleBusiness().then(({ data }) => {

                    if (data.status) {
                        setTerminals(data.result.terminals || []);
                        if (data.result.terminals.length)
                            setTerminalNumber(data.result.terminals[0].terminalNo);
                    }
                })
            }
            // if(businessId){
            //     const findBusiness = allBusiness.find(b => b.id == businessId);
            //     if(findBusiness){
            //         setTerminalNumber(findBusiness.terminalNo);
            //         setSerialNumber(findBusiness.serialNo);
            //     }
            // }
        }
    }, [businessId])

    useEffect(() => {
        setServiceId(0);
        setSubServiceId(0);
        if (groupId)
            getServices().then(({ data }) => {
                let services = [];
                if (data.status) {
                    setAllServices(data.result);
                    data.result.map(item => {
                        services.push({
                            label: item.title,
                            value: item.id
                        });
                    })
                }
                setServices(services);
            });
    }, [groupId])

    useEffect(() => {
        setSubServiceId(0);
        if (serviceId)
            getSubServices().then(({ data }) => {
                let subServices = [];
                if (data.status) {
                    setAllSubServices(data.result);
                    data.result.map(item => {
                        subServices.push({
                            label: item.title,
                            value: item.id
                        });
                    })
                }
                setSubServices(subServices);
            });
    }, [serviceId])

    useEffect(() => {
        calcBasketTotalPrice();
        setHasError(basket.length > 0 ? false : true);
    }, [basket])

    useEffect(() => {
        if (step == 1 && nationalCode && Object.keys(person).length)
            setHasError(false);
        else if (step == 2 && basket.length)
            setHasError(false);
        else
            setHasError(true);
        if (step == 4)
            getServiceConsumerData({ serviceConsumerId, additionalInfo: [] }).then(({ data }) => {
                if (data.status)
                    setFactor(data.result);
                else
                    data.errors.map(error => toast.error(error.message));
            })
    }, [step])

    useEffect(() => {
        if (paymentId != 0) {
            let now = 60;
            let timer = setInterval(() => {
                now--;
                if (now == 0) {
                    clearInterval(timer);
                    getPayment().then(({ data }) => {
                        if (data.result.status && data.result.responseCode == '00')
                            toast.success('پرداخت شما با موفقیت در سیستم ثبت شد');
                        else
                            toast.warning('اطلاعات پرداخت شما یافت نشد');
                    })
                }
            }, 1000);
        }
    }, [paymentId])

    const addToBasket = () => {
        let checkExists = basket.findIndex(item => item.id == subServiceId);
        if(basket.length > 0){
            if(businessId != basket[0].businessId){
                toast.warning('امکان خرید از چند فروشگاه در یک سبد خرید وجود ندارد');
                return;
            }
        }
        if (checkExists >= 0) {
            plusBasketItem(checkExists);
        } else {
            let subService = allSubServices.find(subService => subService.id == subServiceId);            
            setBasket(oldBasket => [...oldBasket, { id: subService.id, title: subService.title || subService.description, count: 1, price: subService.price, businessId: businessId }]);
        }
    }

    const plusBasketItem = index => {
        let newBasket = [...basket];
        newBasket[index].count += 1;
        setBasket(() => [...newBasket]);
    }

    const minusBasketItem = index => {
        let newBasket = [...basket];
        newBasket[index].count -= 1;
        if (newBasket[index].count == 0)
            setBasket(() => [...newBasket.filter((item, itemIndex) => itemIndex != index)]);
        else
            setBasket(() => [...newBasket]);
    }

    const calcBasketTotalPrice = () => {
        let calcTotalPrice = deliverAmount || 0;
        basket.map(item => {
            calcTotalPrice += item.count * item.price;
        })
        setTotalAmount(calcTotalPrice);
    }

    const submitServiceConsuer = () => {
        document.getElementById('submit-service-consumer').classList.add('btn-loading');
        let subServicesId = [];
        basket.map(item => {
            for (let i = 0; i < item.count; i++)
                subServicesId.push(item.id);
        });
        let additionalInfo = [];
        if (userDetails.name)
            additionalInfo.push({ key: 'firstName', value: userDetails.name });
        if (userDetails.lastName)
            additionalInfo.push({ key: 'lastName', value: userDetails.lastName });
        if (userDetails.cellphone)
            additionalInfo.push({ key: 'mobile', value: userDetails.cellphone });
        if (userDetails.nationalCode)
            additionalInfo.push({ key: 'nationalCode', value: userDetails.nationalCode });
        if (userDetails.insuranceNo)
            additionalInfo.push({ key: 'insuranceNo', value: userDetails.insuranceNo });
        if (userDetails.description)
            additionalInfo.push({ key: 'description', value: userDetails.description });
        const postedData = {
            personId: person.id,
            subServiceId: subServicesId,
            additionalInfo,
            addressId: addressId
        };
        createServiceConsumer(postedData).then(({ data }) => {
            if (data.status) {
                setServiceConsumerId(data.result.serviceConsumerId);
                setStep(step + 1);
            } else {
                if(data.errors && data.errors.length > 0)
                    data.errors.map(error => toast.error(error.message));
                else
                    toast.error(data.message)
            }
        }).finally(() => {
            document.getElementById('submit-service-consumer').classList.remove('btn-loading');
        })
    }

    const submitPayment = () => {
        if (paymentType == 'cash') {
            const paymentPostedData = {
                serviceConsumerId,
                status: true,
                responseCode: '00',//data.responseCode,
                amount: factor.totalPay,
                hashedPan: '',
                terminalId: '',//terminalNumber.toString(),
                paymentType: 3,
                pan: '',//data.data.pan.toString().replace(/ /g,''),
                rrn: '',//data.data.rrn,
                traceNo: '',//data.data.traceNo
            };
            createPayment(paymentPostedData).then(({ data }) => {
                if (data.status) {
                    setIsPaid(true);
                    setTotalPaidAmount(oldAmount => factor.totalPay);
                    toast.success('پرداخت با موفقیت در سیستم ثبت شد')
                } else
                    data.errors.map(error => toast.error(error.message));
            })
        } else {
            let timerInterval;
            Swal.fire({
                html: 'در انتظار پرداخت <br style="margin-bottom: 10px"><b>30</b> ثانیه تا اتمام مهلت پرداخت',
                imageUrl: '/assets/images/payment-loader.svg',
                imageWidth: '60px',
                showConfirmButton: false,
                allowOutsideClick: false,
                timer: 30 * 1000,
                didOpen: () => {
                    const b = Swal.getHtmlContainer().querySelector('b');
                    let timer = 30;
                    timerInterval = setInterval(() => {
                        timer--;
                        if (b)
                            b.textContent = timer;
                    }, 1000)
                },
                timerProgressBar: true
            });
            const paymentPostedData = {
                serviceConsumerId,
                status: true,
                amount: factor.totalPay || 0,
                hashedPan: '',
                paymentType: 1,
                pan: '',
                rrn: '',
                responseCode: '',
                terminalId: terminalNumber.toString()
            };
            createPayment(paymentPostedData).then(({ data }) => {
                if (data.status) {
                    setIsPaid(true);
                    setTotalPaidAmount(oldAmount => factor.totalPay);
                    setPaymentId(data.result.id);
                } else
                    data.errors.map(error => toast.error(error.message));
            })
        }
    }

    const submitDebitPayment = () => {
        let timerInterval;
        Swal.fire({
            html: 'در انتظار پرداخت <br style="margin-bottom: 10px"><b>30</b> ثانیه تا اتمام مهلت پرداخت',
            imageUrl: '/assets/images/payment-loader.svg',
            imageWidth: '60px',
            showConfirmButton: false,
            allowOutsideClick: false,
            timer: 30 * 1000,
            didOpen: () => {
                const b = Swal.getHtmlContainer().querySelector('b');
                let timer = 30;
                timerInterval = setInterval(() => {
                    timer--;
                    if (b)
                        b.textContent = timer;
                }, 1000)
            },
            timerProgressBar: true
        });
        const paymentPostedData = {
            serviceConsumerId,
            status: true,
            amount: debitAmount,
            hashedPan: '',
            paymentType: 1,
            pan: '',
            rrn: '',
            responseCode: '',
            terminalId: terminalNumber.toString()
        };
        createPayment(paymentPostedData).then(({ data }) => {
            if (data.status) {
                setDebitPaid(true);
                setTotalPaidAmount(oldAmount => parseInt(totalPaidAmount) + parseInt(debitAmount));
                setPaymentId(data.result.id);
            } else
                data.errors.map(error => toast.error(error.message));
        })
    }

    const submitCashPayment = () => {
        if (paymentType == 'debit-card') {
            let timerInterval;
            Swal.fire({
                html: 'در انتظار پرداخت <br style="margin-bottom: 10px"><b>30</b> ثانیه تا اتمام مهلت پرداخت',
                imageUrl: '/assets/images/payment-loader.svg',
                imageWidth: '60px',
                showConfirmButton: false,
                allowOutsideClick: false,
                timer: 30 * 1000,
                didOpen: () => {
                    const b = Swal.getHtmlContainer().querySelector('b');
                    let timer = 30;
                    timerInterval = setInterval(() => {
                        timer--;
                        if (b)
                            b.textContent = timer;
                    }, 1000)
                },
                timerProgressBar: true
            });
            const paymentPostedData = {
                serviceConsumerId,
                status: true,
                amount: cashAmount,
                hashedPan: '',
                pan: '',
                rrn: '',
                responseCode: '',
                terminalId: terminalNumber.toString(),
                paymentType: 2
            };
            createPayment(paymentPostedData).then(({ data }) => {
                if (data.status) {
                    setCashPaid(true);
                    setTotalPaidAmount(oldAmount => parseInt(totalPaidAmount) + parseInt(cashAmount));
                    setPaymentId(data.result.id);
                } else
                    data.errors.map(error => toast.error(error.message));
            })
        } else {
            const paymentPostedData = {
                serviceConsumerId,
                status: true,
                responseCode: '00', //data.responseCode,
                amount: cashAmount,
                hashedPan: '',
                paymentType: 3,
                terminalId: '', //terminalNumber.toString(),
                pan: '', //data.data.pan.toString().replace(/ /g,''),
                rrn: '', //data.data.rrn,
                traceNo: '', //data.data.traceNo
            };
            createPayment(paymentPostedData).then(({ data }) => {
                if (data.status) {
                    setCashPaid(true);
                    setTotalPaidAmount(oldAmount => parseInt(totalPaidAmount) + parseInt(cashAmount));
                    toast.success('پرداخت با موفقیت در سیستم ثبت شد')
                } else
                    data.errors.map(error => toast.error(error.message));
            })
        }
    }

    const startCounter = () => {
        setOtpCounter(120)
        let interCounter = 120
        const interval = setInterval(() => {
            if(interCounter > 0){
                interCounter -= 1
                setOtpCounter(interCounter)
            }
            if(interCounter == 0){
                clearInterval(interval)
                setSentOtp(false)
            }
        },1000)
    }

    useEffect(() => {
        if(sentOtp)
            startCounter()
    },[sentOtp])

    const getCloseLoopToken = () => {
        const paymentPostedData = {
            orderno: serviceConsumerId.toString(),
            terminalNo: terminalNumber.toString()
        };
        getToken(paymentPostedData).then(({ data }) => {
            setSentOtp(true)
            if(data.status && data.result.status){
                toast.success('پیامک انجام تراکنش برای دارنده ی کارت ارسال شد');
            }else
                data.errors.map(error => toast.error(error.message));
        })
    }

    const submitOnlinePayment = () => {
        const paymentPostedData = {
            orderno: serviceConsumerId.toString(),
            amount: totalAmount,
            terminalNo: terminalNumber.toString()
        };
        getToken(paymentPostedData).then(({ data }) => {
            if (data.status && data.result.status)
                window.location.href = data.result.redirectUrl + '' + data.result.result.paymentToken;
            else
                data.errors.map(error => toast.error(error.message));
        })
    }

    const submitCreditPayment = () => {
        document.getElementById('submit-pay-btn').classList.add('btn-loading')
        const postedData = {
            consumerId: serviceConsumerId,
            otpCode: otp
        }
        addPayment(postedData).then(({ data }) => {
            if(data.status){
                toast.success('سفارش شما با موفقیت ثبت شد')
                navigate('/service-consumer')
            }else
                data.errors.length ? data.errors.map(error => toast.error(error.message)) : toast.error(data.message)
        }).finally(() => {
            document.getElementById('submit-pay-btn').classList.remove('btn-loading')
        })
    }

    const initialValues = {
        provinceId: '',
        cityId: '',
        title: '',
        address: '',
        buildingNo: '',
        floor: '',
        unit: '',
        postalCode: '',
        phone: ''
    }

    const validationSchema = Yup.object({
        provinceId: Yup.string().required(),
        cityId: Yup.string().required(),
        title: Yup.string().required(),
        address: Yup.string().required(),
        buildingNo: Yup.number(),
        floor: Yup.number(),
        unit: Yup.number(),
        postalCode: Yup.string(),
        phone: Yup.string().required(),
    })

    const onSubmit = values => {
        const postedData = {
            ...values,
            personId: personID
        }
        if(!values.buildingNo)
            delete postedData.buildingNo
        if(!values.floor)
            delete postedData.floor
        if(!values.unit)
            delete postedData.unit
        addAddress(postedData).then(({ data }) => {
            if(data.status){
                getAddress()
                document.getElementById('close-modal-btn').click()
                toast.success('آدرس جدید با موفقیت افزوده شد')
                formik.setValues({...initialValues})
            }else
                toast.error(data.message)
        })
    }

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit
    })

    const resetFormik = () => {
        formik.setValues({...initialValues})
    }

    const { readGetDataById: getCities } = useEntityCrud(`Info/GetCities?provinceId=${formik.values.provinceId}`)

    useEffect(() => {
        getProvinces().then(({ data }) => {
            if(data.status){
                let getProvinces = [];
                data.result.map(item => getProvinces.push({
                    label: item.title,
                    value: item.id
                }))
                setProvinces(getProvinces);
            }
        })
    },[])

    useEffect(() => {
        getCities().then(({ data }) => {
            if(data.status){
                let getCities = [];
                data.result.map(item => getCities.push({
                    label: item.title,
                    value: item.id
                }))
                setCities(getCities);
            }
        })
    },[formik.values.provinceId])

    return (
        <div className="card">
            <div className="card-body">
                <div className="wizard">
                    <div className="steps clearfix">
                        <ul role="tablist">
                            <li role="tab" className={step == 1 ? 'current' : 'disabled'} aria-disabled="false" aria-selected="true"><a id="wizard2-t-0" onClick={e => e.preventDefault()} href="#wizard2-h-0" aria-controls="wizard2-p-0"><span className="current-info audible">مرحله فعلی: </span><span className="number">1</span> <span className="title">اطلاعات شخصی</span></a></li>
                            <li role="tab" className={step == 2 ? 'current' : 'disabled'} aria-disabled="true"><a id="wizard2-t-1" href="#wizard2-h-1" onClick={e => e.preventDefault()} aria-controls="wizard2-p-1"><span className="number">2</span> <span className="title">انتخاب سرویس ها / خدمات</span></a></li>
                            <li role="tab" className={step == 3 ? 'current' : 'disabled'} aria-disabled="true"><a id="wizard2-t-2" href="#wizard2-h-2" onClick={e => e.preventDefault()} aria-controls="wizard2-p-2"><span className="number">3</span> <span className="title">پیش فاکتور</span></a></li>
                            <li role="tab" className={step == 4 ? 'current' : 'disabled'} aria-disabled="true"><a id="wizard2-t-2" href="#wizard2-h-2" onClick={e => e.preventDefault()} aria-controls="wizard2-p-2"><span className="number">4</span> <span className="title">پرداخت فاکتور نهایی</span></a></li>
                        </ul>
                    </div>
                    <div className="content clearfix">
                        {step == 1 ? <section className="body">
                            <div className="row">
                                <form className="col-md-3" onSubmit={e => findPerson(e)}>
                                    <div className="form-group">
                                        <label>کد ملی</label>
                                        <div className="input-group">
                                            <input type="tel" className="form-control ltr-input" aria-describedby="button-addon" maxLength={10} onChange={e => setNationalCode(e.target.value)} value={nationalCode} />
                                            <button className="btn btn-info btn-icon" type="submit" id="button-addon" disabled={!nationalCode || nationalCode.length != 10}><i className="fe fe-search"></i></button>
                                        </div>
                                    </div>
                                </form>
                                {Object.keys(person).length && searched ? <div className="col-12">
                                    <hr />
                                    <h5>اطلاعات کاربر</h5>
                                    <table className="table table-hover text-nowrap text-md-nowrap table-striped">
                                        <tbody>
                                            <tr>
                                                <td>نام:</td>
                                                <td>{person.name}</td>
                                            </tr>
                                            <tr>
                                                <td>نام خانوادگی:</td>
                                                <td>{person.lastName}</td>
                                            </tr>
                                            <tr>
                                                <td>شماره ثابت:</td>
                                                <td>{person.phone}</td>
                                            </tr>
                                            <tr>
                                                <td>شماره همراه:</td>
                                                <td>{person.cellphone}</td>
                                            </tr>
                                            <tr>
                                                <td>آدرس ایمیل:</td>
                                                <td>{person.email || '-'}</td>
                                            </tr>
                                            <tr>
                                                <td>شرکت:</td>
                                                <td>{person.branchTitle}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <h5>اطلاعات استفاده کننده</h5>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>نام</label>
                                                <input type="text" className="form-control" value={userDetails.name} onChange={e => setUserDetails({ ...userDetails, name: e.target.value })} />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>نام خانوادگی</label>
                                                <input type="text" className="form-control" value={userDetails.lastName} onChange={e => setUserDetails({ ...userDetails, lastName: e.target.value })} />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>کد ملی</label>
                                                <InputMask mask="9999999999" type="tel" className="form-control ltr-input" value={userDetails.nationalCode} onChange={e => setUserDetails({ ...userDetails, nationalCode: e.target.value })} />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>شماره همراه</label>
                                                <InputMask mask="9999-9999999" type="tel" className="form-control ltr-input" value={userDetails.cellphone} onChange={e => setUserDetails({ ...userDetails, cellphone: e.target.value })} />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>شماره بیمه</label>
                                                <input type="tel" className="form-control ltr-input" value={userDetails.insuranceNo} onChange={e => setUserDetails({ ...userDetails, insuranceNo: e.target.value })} />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>تاریخ اعتبار بیمه</label>
                                                <InputMask mask="9999/99/99" type="tel" className="form-control ltr-input" value={userDetails.insuranceDate} onChange={e => setUserDetails({ ...userDetails, insuranceDate: e.target.value })} />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>توضیحات</label>
                                                <input type="text" className="form-control" value={userDetails.description} onChange={e => setUserDetails({ ...userDetails, description: e.target.value })} />
                                            </div>
                                        </div>

                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <div className="d-flex justify-content-between mt-3">
                                                    <h6 className="mb-4"><b> آدرس </b></h6>
                                                    <button className="btn btn-dark" type="button" data-bs-toggle="modal" data-bs-target="#add-address" onClick={resetFormik}>افزودن آدرس جدید</button>
                                                </div>
                                                <div class="modal fade" id="add-address" tabindex="-1" aria-hidden="true">
                                                    <div class="modal-dialog">
                                                        <form class="modal-content" onSubmit={formik.handleSubmit}>
                                                            <div class="modal-header">
                                                                <h1 class="modal-title" style={{fontSize: 17}}>افزودن آدرس جدید</h1>
                                                                <button type="button" class="btn-close" id="close-modal-btn" data-bs-dismiss="modal" aria-label="Close"></button>
                                                            </div>
                                                            <div class="modal-body">
                                                                <div className="row">
                                                                    <div className="col-6">
                                                                        <FormikReactSelect formik={formik} required={true} label="استان" name="provinceId" options={provinces} value={provinces.find(e => e.value == formik.values.provinceId)} />
                                                                    </div>
                                                                    <div className="col-6">
                                                                        <FormikReactSelect formik={formik} required={true} label="شهر" name="cityId" options={cities} isDisabled={!cities.length} value={cities.find(e => e.value == formik.values.cityId)} />
                                                                    </div>
                                                                </div>
                                                                <Input formik={formik} label="عنوان آدرس" name="title" required={true} />
                                                                <Textarea formik={formik} label="آدرس" name="address" rows={5} />
                                                                <div className="row">
                                                                    <div className="col-md-4">
                                                                        <Input formik={formik} type="tel" isLtr={true} label="پلاک" name="buildingNo" />
                                                                    </div>
                                                                    <div className="col-md-4">
                                                                        <Input formik={formik} type="tel" isLtr={true} label="طبقه" name="floor" />
                                                                    </div>
                                                                    <div className="col-md-4">
                                                                        <Input formik={formik} type="tel" isLtr={true} label="واحد" name="unit" />
                                                                    </div>
                                                                </div>
                                                                <div className="row">
                                                                    <div className="col-md-6">
                                                                        <Input formik={formik} label="کد پستی" type="tel" isLtr={true} maxLength={10} name="postalCode" />
                                                                    </div>
                                                                    <div className="col-md-6">
                                                                        <Input formik={formik} label="شماره همراه" type="tel" isLtr={true} name="phone" required={true} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="modal-footer">
                                                                <button type="button" class="btn btn-danger" data-bs-dismiss="modal" onClick={resetFormik}>لغو</button>
                                                                <button class="btn btn-success">ذخیره اطلاعات</button>
                                                            </div>
                                                        </form>
                                                    </div>
                                                </div>
                                                {personAddress?.map((item, index) => (
                                                    <label className="custom-control custom-radio">
                                                        <input type="radio" className="custom-control-input"
                                                            name="payment-type" value={`address${index}`}
                                                            onChange={e => {
                                                                setAddressType(`${item.address || "-"} 
                                                            -  ساختمان ${item.buildingNo || "-"}  -
                                                             طبقه ${item.floor || "-"} -
                                                              واحد ${item.unit || "-"}`)
                                                                setAddressId(item.id);
                                                            }
                                                            } />
                                                        <span className="custom-control-label">
                                                            <span>{item.title} - {item.provinceTitle} - {item.cityTitle}</span>
                                                            {item.address ? item.address : ""}
                                                            {item.buildingNo ? ' - ' + 'ساختمان' + item.buildingNo : ""}
                                                            {item.floor ? ' - ' + 'طبقه' + item.floor : ""}
                                                            {item.unit ? ' - ' + 'واحد' + item.unit : ""}
                                                        </span>
                                                    </label>
                                                ))}

                                                <hr />
                                            </div>
                                        </div>


                                    </div>
                                </div> : !Object.keys(person).length && searched ? <div className="col-md-12"><div className="alert alert-info">شخص مورد نظر در سیستم یافت نشد</div></div> : ''}
                            </div>
                        </section> : step == 2 ?
                            <section className="body">
                                <div className="row">
                                    <div className="col-md-8">
                                        <div className="row">
                                            {roleId != 3 ? <div className="col-md-3">
                                                <div className="form-group">
                                                    <label>کسب و کار</label>
                                                    <ReactSelect options={business} noOptionsMessage={e => 'یافت نشد'} placeholder="انتخاب کنید" onChange={e => setBusinessId(e.value)} value={business.filter(item => item.value == businessId)} />
                                                </div>
                                            </div> : ''}
                                            <div className={roleId == 3 ? 'col-md-3' : 'col-md-2'}>
                                                <div className="form-group">
                                                    <label>گروه</label>
                                                    <ReactSelect options={groups} noOptionsMessage={e => 'یافت نشد'} placeholder="انتخاب کنید" onChange={e => setGroupId(e.value)} value={groups.filter(item => item.value == groupId)} />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label>سرویس</label>
                                                    <ReactSelect options={services} noOptionsMessage={e => 'یافت نشد'} placeholder="انتخاب کنید" onChange={e => setServiceId(e.value)} value={services.filter(item => item.value == serviceId)} />
                                                </div>
                                            </div>
                                            <div className={roleId == 3 ? 'col-md-4' : 'col-md-2'}>
                                                <div className="form-group">
                                                    <label>محصول / خدمت</label>
                                                    <ReactSelect options={subServices} noOptionsMessage={e => 'یافت نشد'} placeholder="انتخاب کنید" onChange={e => setSubServiceId(e.value)} value={subServices.filter(item => item.value == subServiceId)} />
                                                </div>
                                            </div>
                                            <div className="col-md-2">
                                                <button className="btn btn-success btn-block btn-without-label" disabled={!groupId || !serviceId || !subServiceId} onClick={addToBasket}>افزودن به سبد خرید</button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="card text-primary bg-primary-transparent card-transparent basket basketInMobile">
                                            <div className="card-body">
                                                <h4 className="card-title">سبد خرید</h4>
                                                <hr />
                                                <ul className="list-group list-group-flush mt-5">
                                                    {basket.length < 1 ? <li className="list-group-item bg-primary-transparent text-center">سبد خرید خالی است !</li> : basket.map((item, index) => (
                                                        <li key={index} className="list-group-item bg-primary-transparent mobileGrid_">
                                                            {item.title}
                                                            <button className="btn btn-icon btn-danger float-end" onClick={e => minusBasketItem(index)}><i className="fe fe-minus"></i></button>
                                                            <span className="btn btn-icon float-end">{item.count}</span>
                                                            <button className="btn btn-icon btn-success float-end" onClick={e => plusBasketItem(index)}><i className="fe fe-plus"></i></button>
                                                        </li>
                                                    ))}
                                                </ul>
                                                {basket.length > 0 ? <hr /> : ''}
                                                {basket.length > 0 && addressId ? <p className="mt-5"><b>هزینه ارسال: </b>{new Intl.NumberFormat('en-IR', { maximumSignificantDigits: 20 }).format(deliverAmount)} ریال</p> : ''}
                                                {basket.length > 0 ? <p className="mt-5"><b>مبلغ کل: </b>{new Intl.NumberFormat('en-IR', { maximumSignificantDigits: 20 }).format(totalAmount)} ریال</p> : ''}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                            : step == 3 ?
                                <section className="body">
                                    <h5>
                                        جزئیات پیش فاکتور

                                    </h5>

                                    <table className="table border text-nowrap text-md-nowrap table-bordered mb-0  d-none d-sm-block">
                                        <thead>
                                            <tr>
                                                <th>ردیف</th>
                                                <th>سرویس / خدمت</th>
                                                <th>مبلغ</th>
                                                <th>تعداد</th>
                                                <th>مبلغ کل</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                basket.map((orderItem, index) => (
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{orderItem.title}</td>
                                                        <td>{new Intl.NumberFormat('en-IR', { maximumSignificantDigits: 20 }).format(orderItem.price)} ریال</td>
                                                        <td>{orderItem.count}</td>
                                                        <td>{new Intl.NumberFormat('en-IR', { maximumSignificantDigits: 20 }).format(orderItem.price * orderItem.count)} ریال</td>
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                        <tfoot className="bg-light">
                                            {addressId ? <tr>
                                                <td>هزینه ارسال:</td>
                                                <td colSpan="4">{new Intl.NumberFormat('en-IR', { maximumSignificantDigits: 20 }).format(deliverAmount)} ریال</td>
                                            </tr> : ''}
                                            <tr>
                                                <td>مبلغ کل:</td>
                                                <td colSpan="4">{new Intl.NumberFormat('en-IR', { maximumSignificantDigits: 20 }).format(totalAmount)} ریال</td>
                                            </tr>
                                        </tfoot>
                                    </table>


                                    <div class="card mobileBasket_ d-block d-sm-none">
                                        {basket.map((orderItem, index) => (
                                            <ul class="list-group list-group-flush mb-4 border p-0">
                                                <li class="list-group-item bg-light">
                                                    سرویس / خدمت
                                                    <span className='mx-2'>
                                                        :
                                                    </span>
                                                    {orderItem.title}
                                                </li>
                                                <li class="list-group-item bg-light">
                                                    مبلغ
                                                    <span className='mx-2'>
                                                        :
                                                    </span>
                                                    {new Intl.NumberFormat('en-IR', { maximumSignificantDigits: 20 }).format(orderItem.price)}   ریال
                                                </li>
                                                <li class="list-group-item bg-light">   تعداد
                                                    <span className='mx-2'>
                                                        :
                                                    </span>
                                                    {orderItem.count}
                                                </li>
                                                <li class="list-group-item bg-light">   مبلغ کل
                                                    <span className='mx-2'>
                                                        :
                                                    </span>
                                                    {new Intl.NumberFormat('en-IR', { maximumSignificantDigits: 20 }).format(orderItem.price * orderItem.count)} ریال
                                                </li>
                                            </ul>
                                        ))
                                        }

                                        <div class="card-header" style={{ background: "#f3f3f3" }}>
                                            مبلغ کل    <span className='mx-2'>
                                                :
                                            </span>
                                            {new Intl.NumberFormat('en-IR', { maximumSignificantDigits: 20 }).format(totalAmount)} ریال
                                        </div>
                                    </div>



                                </section>
                                :
                                <section className="body">
                                    <h5>
                                        فاکتور نهایی
                                        به شناسه :
                                        &nbsp;  {serviceConsumerId}
                                    </h5>

                                    <table className="table border text-nowrap text-md-nowrap table-bordered mb-0 d-none d-sm-block">
                                        <thead>
                                            <tr>
                                                <th>ردیف</th>
                                                <th>سرویس / خدمت</th>
                                                <th>مبلغ</th>
                                                <th>تعداد</th>
                                                <th>مبلغ کل</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                basket.map((orderItem, index) => (
                                                    <tr>
                                                        <td>{index + 1}</td>
                                                        <td>{orderItem.title}</td>
                                                        <td>{new Intl.NumberFormat('en-IR', { maximumSignificantDigits: 20 }).format(orderItem.price)} ریال</td>
                                                        <td>{orderItem.count}</td>
                                                        <td>{new Intl.NumberFormat('en-IR', { maximumSignificantDigits: 20 }).format(orderItem.price * orderItem.count)} ریال</td>
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                        <tfoot className="bg-light">
                                            <tr>
                                                <td>مبلغ کل:</td>
                                                <td colSpan="4">{new Intl.NumberFormat('en-IR', { maximumSignificantDigits: 20 }).format(factor.totalAmount)} ریال</td>
                                            </tr>
                                            <tr>
                                                <td>مبلغ تخفیف:</td>
                                                <td colSpan="4">{new Intl.NumberFormat('en-IR', { maximumSignificantDigits: 20 }).format(factor.totalDiscount)} ریال</td>
                                            </tr>
                                            <tr>
                                                <td>مبلغ نهایی (قابل پرداخت):</td>
                                                <td colSpan="4">{new Intl.NumberFormat('en-IR', { maximumSignificantDigits: 20 }).format(factor.totalPay)} ریال</td>
                                            </tr>
                                        </tfoot>
                                    </table>

                                    <div class="card mobileBasket_ d-block d-sm-none">
                                        {basket.map((orderItem, index) => (
                                            <ul class="list-group list-group-flush">
                                                <li class="list-group-item">
                                                    سرویس / خدمت
                                                    <span className='mx-2'>
                                                        :
                                                    </span>
                                                    {orderItem.title}
                                                </li>
                                                <li class="list-group-item">
                                                    مبلغ
                                                    <span className='mx-2'>
                                                        :
                                                    </span>
                                                    {new Intl.NumberFormat('en-IR', { maximumSignificantDigits: 20 }).format(orderItem.price)}   ریال
                                                </li>
                                                <li class="list-group-item">   تعداد
                                                    <span className='mx-2'>
                                                        :
                                                    </span>
                                                    {orderItem.count}
                                                </li>
                                                <li class="list-group-item">   مبلغ کل
                                                    <span className='mx-2'>
                                                        :
                                                    </span>
                                                    {new Intl.NumberFormat('en-IR', { maximumSignificantDigits: 20 }).format(orderItem.price * orderItem.count)} ریال
                                                </li>
                                            </ul>
                                        ))
                                        }

                                        <div class="card-header" style={{ background: "#f3f3f3" }}>
                                            مبلغ کل    <span className='mx-2'>
                                                :
                                            </span>
                                            {new Intl.NumberFormat('en-IR', { maximumSignificantDigits: 20 }).format(totalAmount)} ریال
                                        </div>

                                        <div class="card-header" style={{ background: "#f3f3f3" }}>
                                            مبلغ تخفیف  <span className='mx-2'>
                                                :
                                            </span>
                                            {new Intl.NumberFormat('en-IR', { maximumSignificantDigits: 20 }).format(totalAmount)} ریال
                                        </div>

                                        <div class="card-header" style={{ background: "#f3f3f3" }}>
                                            مبلغ نهایی    <span className='mx-2'>
                                                :
                                            </span>
                                            {new Intl.NumberFormat('en-IR', { maximumSignificantDigits: 20 }).format(totalAmount)} ریال
                                        </div>

                                    </div>

                                </section>
                        }
                    </div>
                    {!isPaid ? <div className="actions clearfix">
                        <ul role="menu" aria-label="صفحه بندی" className="d-block">
                            {step > 1 && step != 4 ? <li className="disabled float-start" aria-disabled="true"><button className="btn btn-light" href="#previous" role="menuitem" onClick={e => setStep(step - 1)}>قبلی</button></li> : ''}
                            {step == 1 || step == 2 ? <li className="float-end" aria-hidden="false" aria-disabled="false"><button className="btn btn-info" disabled={hasError} href="#next" role="menuitem" onClick={e => setStep(step + 1)}>بعدی</button></li> : ''}
                            {step == 3 ? <li aria-hidden="false" className="float-end" aria-disabled="false"><button className="btn btn-primary" id="submit-service-consumer" href="#next" role="menuitem" onClick={submitServiceConsuer}>تایید و ثبت پیش فاکتور</button></li> : ''}
                            {step == 4 && totalPaidAmount < totalAmount ? <div>
                                <h6 className="mb-4"><b>روش پرداخت</b></h6>
                                <div className="row">
                                    <div className="col-md-3 mb-3">
                                        <label>ترمینال</label>
                                        <select className='form-control' onChange={e => setTerminalNumber(e.target.value)} value={terminalNumber}>
                                            <option>انتخاب کنید</option>
                                            {terminals.map(item => (
                                                <option value={item.terminalNo}>{item.terminalNo}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <label className="custom-control custom-radio">
                                    <input type="radio" className="custom-control-input" name="payment-type" value="debit" checked={paymentType == 'debit'} onChange={e => setPaymentType('debit')} />
                                    <span className="custom-control-label">پرداخت یکجا (کارت کلوزلوپ یا کارت شتابی)</span>
                                </label>
                                {false ? <label className="custom-control custom-radio">
                                    <input type="radio" className="custom-control-input" name="payment-type" value="cash" checked={paymentType == 'cash'} onChange={e => setPaymentType('cash')} />
                                    <span className="custom-control-label">پرداخت از طریق اسکناس به صورت نقدی</span>
                                </label> : ''}
                                {false && <label className="custom-control custom-radio">
                                    <input type="radio" className="custom-control-input" name="payment-type" value="debit-card" checked={paymentType == 'debit-card'} onChange={e => setPaymentType('debit-card')} />
                                    <span className="custom-control-label">پرداخت ترکیبی (کارت کلوزلوپ + کارت شتابی)</span>
                                </label>}
                                {false ? <label className="custom-control custom-radio">
                                    <input type="radio" className="custom-control-input" name="payment-type" value="debit-cash" checked={paymentType == 'debit-cash'} onChange={e => setPaymentType('debit-cash')} />
                                    <span className="custom-control-label">پرداخت ترکیبی (کارت کلوزلوپ + اسکناس به صورت نقدی)</span>
                                </label> : ''}
                                {false ? <label className="custom-control custom-radio mb-4">
                                    <input type="radio" className="custom-control-input" name="payment-type" value="card-cash" checked={paymentType == 'card-cash'} onChange={e => setPaymentType('card-cash')} />
                                    <span className="custom-control-label">پرداخت ترکیبی (کارت شتابی + اسکناس به صورت نقدی)</span>
                                </label> : ''}
                                {false && <label className="custom-control custom-radio mb-4">
                                    <input type="radio" className="custom-control-input" name="payment-type" value="online" checked={paymentType == 'online'} onChange={e => setPaymentType('online')} />
                                    <span className="custom-control-label">پرداخت آنلاین</span>
                                </label>}
                                <label className="custom-control custom-radio mb-4">
                                    <input type="radio" className="custom-control-input" name="payment-type" value="online" checked={paymentType == 'online'} onChange={e => setPaymentType('online')} />
                                    <span className="custom-control-label">پرداخت مستقیم</span>
                                </label>
                                <hr />
                                {paymentType == 'debit' || paymentType == 'cash' ? <button className="btn btn-success" onClick={submitPayment}>پرداخت</button> :
                                    paymentType == 'online' ? <div className="row">
                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label>رمز یکبار مصرف</label>
                                                <input type="tel" className="form-control" maxLength={6} value={otp} onChange={e => setOtp(e.target.value)} />
                                            </div>
                                        </div>
                                        <div className="col-md-2" style={{marginTop: 30}}>
                                            <button className="btn btn-primary btn-block" onClick={getCloseLoopToken} disabled={sentOtp}>{sentOtp ? `${otpCounter} ثانیه` : 'ارسال رمز یکبار مصرف'}</button>
                                        </div>
                                        <div className="col-md-2" style={{marginTop: 30}}>
                                            <button className="btn btn-success btn-block" id="submit-pay-btn" onClick={submitCreditPayment} disabled={!otp || otp.length != 6}>پرداخت آنلاین</button>
                                        </div>
                                    </div> :
                                        <>
                                            {!debitPaid ? <div className="row">
                                                <div className="col-md-2">
                                                    <div className="form-group">
                                                        <input type="tel" className="form-control ltr-input" placeholder={paymentType.includes('debit') ? 'مبلغ پرداخت اعتباری' : 'مبلغ پرداخت شتابی'} onChange={e => setDebitAmount(e.target.value)} value={!debitAmount || debitAmount == 0 ? '' : debitAmount} />
                                                    </div>
                                                </div>
                                                <div className="col-md-1">
                                                    <button className="btn btn-success btn-block" onClick={submitDebitPayment} disabled={debitAmount < 1}>پرداخت</button>
                                                </div>
                                            </div> : ''}
                                            {!cashPaid ? <div className="row">
                                                <div className="col-md-2">
                                                    <div className="form-group">
                                                        <input type="tel" className="form-control ltr-input" placeholder={paymentType.includes('debit') && !paymentType.includes('cash') ? 'مبلغ پرداخت شتابی' : 'مبلغ پرداخت نقدی'} readOnly value={!cashAmount || cashAmount == 0 ? '' : cashAmount} />
                                                    </div>
                                                </div>
                                                <div className="col-md-1">
                                                    <button className="btn btn-success btn-block" onClick={submitCashPayment} disabled={cashAmount < 1}>پرداخت</button>
                                                </div>
                                            </div> : ''}
                                        </>
                                }
                            </div> : ''}
                        </ul>
                    </div> : ''}
                </div>
            </div>
        </div>
    );
}

export default Create;